import { render } from "./add-event-modal.html?vue&type=template&id=66f81476&scoped=true&ts=true&external"
import script from "./add-event-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-event-modal.ts?vue&type=script&lang=ts&external"

import "./add-event-modal.scss?vue&type=style&index=0&id=66f81476&scoped=true&lang=sccs&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f81476"]])

export default __exports__